import { createRouter, createWebHistory } from "vue-router";
import LayoutPadraoo from "../components/layouts/LayoutPadrao.vue";
import { auth } from "../firebase";
import AcessoService from "../service/AcessoService";
import { temPermissao, PERMISSOES } from "../util/permissoes";

const routesPadrao = [
  {
    path: "",
    name: "cadastroAssociado",
    meta: { requiresAuth: true },
    component: LayoutPadraoo,
    children: [
      {
        path: "/home",
        name: "TelaInicial",
        component: () => import("../views/login/TelaInicial.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/cadastro-pessoa/:id?",
        name: "CadastroUsuarioInterno",
        component: () => import("../views/usuario/CadastroUsuarioInterno.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_USUARIO },
      },
      {
        path: "/sorteador",
        name: "SorteadorCorrupto",
        component: () => import("../views/calendario/SorteadorCorrupto.vue"),
      },

      {
        path: "/cadastro-medicamento/:id?",
        name: "MedicamentoCadastro",
        component: () => import("../views/medicamento/MedicamentoCadastro.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_MEDICAMENTO },
      },
      {
        path: "/catalogo-medicamentos",
        name: "MedicamentoCatalogoGestao",
        component: () => import("../views/medicamento/MedicamentoCatalogoGestao.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_CATALOGO_MEDICAMENTO },
      },
      {
        path: "/pagamento/:id?",
        name: "PagamentoUsuario",
        component: () => import("../views/pagamento/PagamentoUsuario.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_PAGAMENTO },
      },
      {
        path: "/cadastro-usuario/:id?",
        name: "CadastroUsuario",
        component: () => import("../views/usuario/CadastroUsuarioInterno.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_USUARIO },
      },
      {
        path: "/unificar-usuario",
        name: "UnificarUsuario",
        component: () => import("../views/usuario/UsuarioDuplicado.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.EDITAR_USUARIO },
      },
      {
        path: "/gerenciar-permissoes",
        name: "GerenciarPermissoes",
        component: () => import("../views/usuario/GerenciarPermissoes.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.GERENCIAR_PERMISSOES },
      },
      {
        path: "/listar-pessoa/:id?",
        name: "ListarUsuario",
        component: () => import("../views/usuario/ListarUsuario.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.LISTAR_USUARIOS },
      },
      {
        path: "/listar-medicamento/:id?",
        name: "ListarMedicamento",
        component: () => import("../views/medicamento/ListarMedicamento.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.LISTAR_MEDICAMENTOS },
      },
      {
        path: "/calendario",
        name: "AgendaCalendario",
        component: () => import("../views/calendario/CalendarioView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/seminario",
        name: "Quarto",
        component: () => import("../views/casa/Quarto.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.GESTAO_QUARTOS },
      },
      {
        path: "/listar-inscritos-retiro",
        name: "ListarInscritosRetiro",
        component: () => import("../views/casa/ListarInscritosRetiro.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.LISTAR_INSCRITOS_RETIRO },
      },
      {
        path: "/fila-atendimentos",
        name: "GerenciarFila",
        component: () => import("../views/Fila/GerenciarFila.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.GERENCIAR_FILA },
      },
      {
        path: "/painel-fila",
        name: "PainelFila",
        component: () => import("../views/Fila/PainelFila.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.PAINEL_FILA },
      },
    ],
  },
];
const routesSemFundo = [
  {
    path: "/login",
    name: "telaLogin",
    children: [
      {
        path: "/login",
        name: "LoginUsuario",
        component: () => import("../views/login/TelaLogin.vue"),
      },
      {
        path: "/inscricao-retiro",
        name: "InscricaoRetiro",
        component: () => import("../views/casa/InscricaoRetiro.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/inscricao-retiro-equipe-trabalho",
        name: "InscricaoRetiroEquipeTrabalho",
        component: () => import("../views/casa/InscricaoRetiroEquipeTrabalho.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
];

const routes = routesPadrao.concat(routesSemFundo);

const router = createRouter({
  history: createWebHistory("/aom-web-admin"),
  routes,
});

const PERMISSIONS_STORAGE_KEY = "userPermissions";

const obterUsuarioAtual = () =>
  new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });

const carregarPermissoesSeNecessario = async () => {
  const salvas = localStorage.getItem(PERMISSIONS_STORAGE_KEY);
  if (salvas) {
    return JSON.parse(salvas);
  }

  const { data } = await AcessoService.buscarMeuAcesso();
  const permissoes = data?.usuario?.permissoes || [];
  localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(permissoes));
  return permissoes;
};

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiredPermission = to.matched.find((record) => record.meta?.permission)?.meta?.permission;

  if (requiresAuth) {
    const user = await obterUsuarioAtual();

    if (!user) {
      next("/login");
      return;
    }

    if (to.path !== "/login") {
      localStorage.setItem("lastRoute", to.fullPath);
    }

    if (requiredPermission) {
      try {
        const permissoes = await carregarPermissoesSeNecessario();
        if (!temPermissao(permissoes, requiredPermission)) {
          next("/home");
          return;
        }
      } catch (error) {
        localStorage.removeItem(PERMISSIONS_STORAGE_KEY);
        next("/home");
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
